import { Injectable        } from '@angular/core';
import { NotifierManager   } from '../managers/notifier/notifier.manager';
import { Notifier          } from '../enums/notifier/notifier.enum';
import { NotifierMessage   } from '../enums/notifier/message/notifier.enum';
import { MatDialog         } from '@angular/material/dialog';
import { LoginForcedDialog } from '../dialogs/login-forced/login-forced.dialog';

@Injectable
({
  providedIn: 'root'
})

export class LoginError 
{

    constructor
    (
      private _notifier : NotifierManager,
      private _dialog   : MatDialog
    ) {}

    generic () 
    {
      this._notifier.show( Notifier.ERROR, NotifierMessage.LOGIN_GENERIC)
    }

    userDoesntExists()
    {
      this._notifier.show( Notifier.ERROR, NotifierMessage.LOGIN_USER_DOESNT_EXISTS)
    }

    wrongPassword()
    {
      this._notifier.show( Notifier.ERROR, NotifierMessage.LOGIN_WRONG_PASSWORD)
    }

    passwordChangeRequired()
    {
      this._notifier.show( Notifier.INFO, NotifierMessage.LOGIN_PASSWORD_CHANGE_REQUIRED)
    }

    operatorNotAuth()
    {
      this._notifier.show( Notifier.ERROR, NotifierMessage.LOGIN_OPERATOR_NOT_AUTH)
    }

    userAlreadyLogged( params: any )
    {
      return this._dialog.open ( 
        LoginForcedDialog, 
        {
          data: { username: params.username, password: params.password },
          disableClose: true
        } 
      )
    }

}